export default "__VITE_ASSET__Cu4fURm3__"